var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconEmojiAdd = function SvgIconEmojiAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.696 1.87c1.22 0 2.381.25 3.435.705-.428.398-.72.94-.803 1.55a6.957 6.957 0 1 0 4.246 5.393 2.596 2.596 0 0 0 1.76.049 8.695 8.695 0 0 1-8.638 9.694A8.695 8.695 0 0 1 0 10.565 8.695 8.695 0 0 1 8.696 1.87Zm4.443 10.434a4.779 4.779 0 0 1-4.443 3.044 4.776 4.776 0 0 1-4.362-2.849l-.081-.195h8.886ZM5.652 7.087a1.304 1.304 0 1 1 0 2.609 1.304 1.304 0 0 1 0-2.609Zm6.087 0a1.304 1.304 0 1 1 0 2.609 1.304 1.304 0 0 1 0-2.609ZM16.522 1c.48 0 .87.39.87.87l-.002 1.738h1.74a.87.87 0 1 1 0 1.74l-1.74-.001.001 1.74a.869.869 0 0 1-.372.714l-.063.039a.647.647 0 0 1-.075.04l.075-.04a.844.844 0 0 1-.325.11l-.11.007a.87.87 0 0 1-.869-.87v-1.74h-1.739a.87.87 0 0 1 0-1.738l1.738-.001.001-1.738c0-.48.39-.87.87-.87Z",
    fillRule: "nonzero"
  })));
};

export default SvgIconEmojiAdd;